import { type ButtonSize } from './types.js';
import { css, styled } from 'styled-components';

export const StyledButtonContainer = styled.div<{
  readonly $isLoading: boolean;
  readonly size: ButtonSize;
}>`
  ${({ $isLoading, size }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${size === 'xsmall' || size === 'small' ? '6px' : '8px'};
    height: 100%;
    opacity: ${$isLoading ? '0' : '1'};
  `}
`;
